module.exports = __webpack_public_path__ + "static/media/sense4001.79e6c8f3.jpg";